import { usePersistStore } from "hooks/useStore";

export const scope = "storeApp";

export const reqAuth = "reqAuth";

const createApp = (set, get) => ({
  canNavigate: true,

  currentUser: {
    id: null,
    email: null,
    role: null,
    firstName: null,
    lastName: null,
    twoFactorAuth: false,
  },
  handleAppChange: (key, value) => {
    set(
      (s) => ({
        ...s,
        [scope]: {
          ...s[scope],
          [key]: value,
        },
      }),
      false,
      `${scope} : handleAppChange`,
    );
  },

  requestLogout: (cb) => {
    const { handlePSChangeAll } = usePersistStore.getState();

    handlePSChangeAll({ token: null });
    set(
      (s) => ({
        ...s,
        [scope]: {
          ...s[scope],
          currentUser: {
            id: null,
            email: null,
            role: null,
            firstName: null,
            lastName: null,
            twoFactorAuth: false,
          },
        },
      }),
      false,
      `${scope} : handlePSChangeAll`,
    );
    typeof cb === "function" && cb();
  },
});

export default createApp;
